<template>
  <el-container class="parent">
    <el-aside width="350px" class="containerside">
      <div class="flex_between_nowrap">
        <span class="title_before side_title">角色</span>
        <el-button
          @click="add_role('')"
          type="text"
          class="then_color font14"
          icon="iconfont icon-add"
          >新增</el-button
        >
      </div>

      <div class="side_min">
        <el-input
          clearable
          placeholder="请输入内容"
          size="medium"
          class="input_icon"
          suffix-icon="el-icon-search inputIcon"
        ></el-input>
        <el-empty description="" v-if="!roleArr.length"></el-empty>

        <ul
          v-if="roleArr.length"
          style="  max-height: 710px;
  overflow-y: auto;"
          class="user_list"
        >
          <li
            v-for="(item, index) in roleArr"
            :class="index == current_index ? 'user_active' : ''"
            :key="index"
            @click="user_click(item, index)"
          >
            <div>
              <i
                class="iconfont icon-user addColor"
                style="font-size:20px;line-height: 36px"
              ></i>
              <span style="line-height: 36px;height:36px">{{
                item.roleName
              }}</span>
            </div>
            <div>
              <i
                @click.stop="add_role(item.id)"
                class="iconfont icon-xiugai then_color font16"
              ></i>
              <i
                class="el-icon-delete"
                @click.stop="
                  $axiosDelete('/pc/role/del', { id: item.id }, init,'',true)
                "
              ></i>
            </div>
          </li>
        </ul>
      </div>
    </el-aside>
    <el-main class="min">
      <div style="margin-bottom:20px">
        <span class="title_before " style="padding-left:24px">权限</span>
      </div>
      <div style="padding:0px 20px">
        <!-- <div class="flex_between_nowrap" style="margin-bottom:30px"></div> -->

        <div style="position: relative;">
          <el-checkbox-group v-model="checkList">
            <ul class="firstul">
              <li v-for="(item, index) in menuArr" :key="index">
                <el-checkbox :label="item.id" @change="checkChange(item)">{{
                  item.menuName
                }}</el-checkbox>
                <ul v-if="item.newArr" class="childrenul">
                  <li v-for="(children, cIndex) in item.newArr" :key="cIndex">
                    <el-checkbox :label="children.id">{{
                      children.menuName
                    }}</el-checkbox>
                  </li>
                </ul>
              </li>
            </ul>
          </el-checkbox-group>

          <div class="min_foo">
            <div class="flex_end">
              <el-button type="submit" @click="submit">保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      checkList: [],
      current_index: null,
      menuArr: [],
      roleArr: [],
      roleOne: {},
    };
  },
  mounted() {},
  methods: {
    checkChange(item) {
      if (this.checkList.indexOf(item.id) !== -1) {
        for (let i = 0; i < item.newArr.length; i++) {
          let flag = true;
          for (let k = 0; k < this.checkList.length; k++) {
            if (this.checkList[k] == item.newArr[i].id) {
              flag = false;
              break;
            }
          }
          if (flag) {
            this.checkList.push(item.newArr[i].id);
          }
        }
      } else {
        for (let i = 0; i < item.newArr.length; i++) {
          for (let k = 0; k < this.checkList.length; k++) {
            if (this.checkList[k] == item.newArr[i].id) {
              this.checkList.splice(k, 1);
            }
          }
        }

      }
    },
    submit() {
      let submit = this.roleOne;
      submit.ids = this.checkList;
      this.$requestAxiosForm(
        {
          url: "/pc/role/update",
          data: submit,
        },
        (data) => {
          this.$success();
          this.user_click(this.roleArr[this.current_index], this.current_index);
        }
      );
    },
    user_click(item, index) {
      this.current_index = index;

      this.$requestAxios(
        {
          url: "/pc/role/one",
          data: { id: item.id },
        },
        (data) => {
          this.roleOne = data.data;
          this.checkList = data.data.ids;
        }
      );
    },
    add_role(id) {
      this.$createDialog(this, {
        dialogConfig: { title: id ? "角色编辑" : "角色新增", width: "360px" },
        namespace: "sys_add_role",
        whetherDestruction: true,

        assemblyConfig: {
          id: id ? id : "",
          callBack: this.init,
        },
      });
    },

    init() {
      /*角色列表  */
      this.$requestAxios(
        {
          url: "/pc/role/page",
          data: {},
        },
        (data) => {
          this.roleArr = data.data;
          if (this.roleArr.length) {
            this.user_click(this.roleArr[0], 0);
          }
        }
      );
      /*选择组织 权限范围 */

      this.$requestAxios(
        {
          url: "/pc/menu/tree",
          data: {},
        },
        (data) => {
          // this.$treeChildrenEmp(data.data);
          // this.menuArr = data.data;
          let arr = data.data;
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].children) {
              arr[i].newArr = this.$arrflat(arr[i].children, []);
            }
          }

          this.menuArr = arr;
        }
      );
    },
  },
};
</script>
<style scoped>
ul,
li {
  padding: 0;
  margin: 0;
}
.firstul {
}
.firstul > li {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 43px;
  padding-top: 55px;
}
.firstul > li:first-child {
  padding-top: 20px;
}
.min_foo {
  position: fixed;
  bottom: 22px;
  right: 40px;
  width: 100%;
}
.min_foo > div {
  height: 80px;
}
.childrenul {
  display: flex;
  flex-flow: row wrap;
  margin-left: 28px;
}
.childrenul > li {
  margin-right: 40px;
  margin-top: 20px;
}
.parent {
  height: 100%;
  background-color: #f6f7fc;
}

.side_min {
  padding-left: 20px;
  margin-top: 20px;
  height: 100%;
}
.input_icon {
  margin-bottom: 30px;
}

.user_list,
.user_list li {
  margin: 0;
  padding: 0;
}
.user_list li {
  padding-left: 22px;
  padding-right: 10px;
  background-color: #fff;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
.user_list li > div:last-child {
  display: none;
}
.user_list li > div:first-child > span {
  font-size: 14px;
  line-height: 24px;
  margin-left: 10px;
  color: #333333;
  line-height: 36px;
}
.user_list li:hover {
  background-color: #f3f6fb;
  border-radius: 2px;
}
.user_list li > div:last-child > i:last-child {
  margin-left: 10px;
  opacity: 0.8;
}

.user_list li:hover > div:last-child {
  display: block;
}

.user_active {
  background-color: #f3f6fb !important;
  border-radius: 2px;
}
.user_active > div:last-child {
  display: block !important;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
.iconList > i {
  padding-right: 10px;
}
.working {
  background-color: #d8e6ff;
  border-radius: 4px;
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0px;
  color: #7c7c7c;
}
.dimission {
  background-color: #e0e0e0;
  border-radius: 4px;
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0px;
  color: #7c7c7c;
}
</style>
